import { useLifeEvents } from '@/data/sources/lifeEvents';
import { slugOf } from '../lib/focusModes';
import { buildFocusSegments } from '../lib/segments';
import { PRAGUE_DAY, WEEK_MS } from '../lib/time';

export interface LifeStats {
  sleepPerNightMinutes: number | null;
  lastSync: number | null;
  syncPerDay: number | null;
}

export const useLifeStats = (): LifeStats => {
  const { data } = useLifeEvents('week');
  const events = data?.events ?? [];
  const now = Date.now();
  const start = new Date(now - WEEK_MS);

  const segments = buildFocusSegments(events, start, new Date(now));
  const sleep = segments.filter((s) => slugOf(s.name) === 'sleep');
  const sleepMinutes = sleep.reduce((sum, s) => {
    const from = Math.max(s.start.getTime(), start.getTime());
    return sum + Math.max(0, (s.end.getTime() - from) / 60_000);
  }, 0);
  const nights = new Set(sleep.map((s) => PRAGUE_DAY.format(s.start))).size;

  const syncTimes = [
    ...new Set(events.map((e) => e.receivedAt.getTime())),
  ].sort((a, b) => a - b);
  const spanDays =
    syncTimes.length > 1
      ? (syncTimes[syncTimes.length - 1] - syncTimes[0]) / 86_400_000
      : 0;

  return {
    sleepPerNightMinutes: nights ? sleepMinutes / nights : null,
    lastSync: syncTimes.at(-1) ?? null,
    syncPerDay: spanDays > 0 ? syncTimes.length / spanDays : null,
  };
};
